import stripe from "./factories/StripePaymentGateway";
appHost.plugins.register({
    // #region Vars
    name: "288a.payment.stripe",
    // #endregion
    // #region Constructor
    register() {
        appHost.components.registerAll(require.context('./views', true, /(?<!views)\.vue$/));
        appHost.provider.register('PAYMENT', 'stripe', new stripe());
    },
    // #endregion
});
